var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3322 3.6667C14.3335 2.19335 11.3468 1 7.66676 1C3.98671 1 1.00267 2.19468 1 3.6667C1 5.14006 3.98404 6.33341 7.66676 6.33341C11.3495 6.33341 14.3335 5.14006 14.3335 3.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3335 3.66672V14.0135",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00134 9.00012C1.00134 10.4735 3.98538 11.6668 7.6681 11.6668C11.3508 11.6668 14.3349 10.4735 14.3349 9.00012",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9096 14.7575C24.2523 17.1002 24.2523 20.9003 21.9096 23.243C19.5669 25.5857 15.7668 25.5857 13.4241 23.243C11.0814 20.9003 11.0814 17.1002 13.4241 14.7575C15.7668 12.4148 19.5669 12.4148 21.9096 14.7575",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3402 16.2336C11.1375 16.7069 9.48813 17.0002 7.66677 17.0002C3.98538 17.0002 1.00134 15.8069 1.00134 14.3335",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2602 21.5923C11.0641 22.0496 9.45212 22.3336 7.66676 22.3336C3.98537 22.3336 1.00133 21.1403 1 19.6669V3.66672",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBalance);
export default __webpack_public_path__ + "static/media/AccountBalance.0b35d29d2ccaec555a4c2f43e065ca43.svg";
export { ForwardRef as ReactComponent };